require("!!/Users/sergeyk/git/wdf/node_modules/mocha-loader/web.js");
mocha.setup("bdd");
require("!!/Users/sergeyk/git/wdf/node_modules/jshint-loader/index.js!/Users/sergeyk/git/wdf/test/index.js")
require("!!/Users/sergeyk/git/wdf/node_modules/mocha-loader/start.js");
if(module.hot) {
	module.hot.accept();
	module.hot.dispose(function() {
		mocha.suite.suites.length = 0;
		var stats = document.getElementById('mocha-stats');
		var report = document.getElementById('mocha-report');
		stats.parentNode.removeChild(stats);
		report.parentNode.removeChild(report);
	});
}


/*****************
 ** WEBPACK FOOTER
 ** ./~/mocha-loader!./test/index.js
 ** module id = 0
 ** module chunks = 0
 **/